/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import { useCallback, useMemo } from 'react';
import { useAppSelector } from 'hooks';
import {
  ServicePermissions,
  PermissionLevel,
  UserProjectPermissions,
} from 'components/Project/types/enums';

export const usePermission = () => {
  const permissions = useAppSelector(
    (state) => state.user.currentProject?.permissions,
  ) as UserProjectPermissions | undefined;

  const hasPermission = useCallback(
    (permission: ServicePermissions): boolean => permissions?.[permission] !== undefined,
    [permissions],
  );

  const hasAnyPermission = useCallback(
    (permissionList: ServicePermissions[]): boolean => permissionList.some((permission) => permissions?.[permission] !== undefined),
    [permissions],
  );

  const hasAllPermissions = useCallback(
    (permissionList: ServicePermissions[]): boolean => permissionList.every((permission) => permissions?.[permission] !== undefined),
    [permissions],
  );

  const isReadPermission = useCallback(
    (permission: ServicePermissions): boolean => permissions?.[permission] === PermissionLevel.READ,
    [permissions],
  );

  const isAnyReadPermission = useCallback(
    (permissionList: ServicePermissions[]): boolean => permissionList.some((permission) => permissions?.[permission] === PermissionLevel.READ),
    [permissions],
  );

  const isWritePermission = useCallback(
    (permission: ServicePermissions): boolean => permissions?.[permission] === PermissionLevel.WRITE,
    [permissions],
  );

  const getPermission = useCallback(
    (permission: ServicePermissions): PermissionLevel | undefined => permissions?.[permission],
    [permissions],
  );

  return useMemo(
    () => ({
      hasPermission,
      hasAnyPermission,
      hasAllPermissions,
      isReadPermission,
      isAnyReadPermission,
      isWritePermission,
      getPermission,
      isLoadedPermission: Boolean(permissions),
    }),
    [hasPermission, isReadPermission, isAnyReadPermission, isWritePermission, getPermission, permissions],
  );
};

// export default usePermission;
